import hcpSignupQuery from "./queries/sign-up-hcp-query";
// import dtcSignupQuery from "./queries/sign-up-dtc-query";
import csrfCookie from "@/util/csrfCookie";
import hcpDirectoryInquiryQuery from "./queries/directory-inquery-hcp-query";

export default async function ApiSignUp({
  formId = undefined,
  formData = undefined,
  guideData = undefined,
  captchaToken = undefined,
}) {
  var success = false, queryMutation;
  // As we are doing the form specific validations on the callEpsilon function, we just need to call it here and the function will handle determing what sort of mutation should be passed, depending on the form used.
  // Because we need to know what the response is for our calls, we set up promises so we can promise all and determine if we can show up the modal for confirmation or not. We do this by keeping track of a promise array that we then submit to the promise.all
  const promiseArray = [];
  const url = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : ''; // test url

  const putJson = async (endpoint, body, headers = {}) => {
    const response = await fetch(endpoint, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      body: JSON.stringify(body),
    });

    let data;
    try {
      data = await response.json();
    } catch (e) {
      data = undefined;
    }

    if (!response.ok) {
      const error = new Error(data?.message || `Request failed with status ${response.status}`);
      /** @type {any} */ (error).response = { data };
      throw error;
    }

    return data;
  };
  const getBearerToken = async () => {
    let csrfToken;
    try {
      csrfToken = csrfCookie();
    } catch (csrfError) {
      console.error('Failed to get CSRF token:', csrfError.message);
      throw new Error('Authentication failed: Unable to retrieve CSRF token');
    }
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': csrfToken, // CSRF token for security
      },
    };
    return await fetch(`${url}/api/get-token`, requestOptions)
      .then(response => response.json())
      .then(data => {
          return data;
      })
      .catch(error => console.error('Error:', error));
  };

  const getEmailBearerToken = async () => {
    let csrfToken;
    try {
      csrfToken = csrfCookie();
    } catch (csrfError) {
      console.error('Failed to get CSRF token:', csrfError.message);
      throw new Error('Authentication failed: Unable to retrieve CSRF token');
    }
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': csrfToken, // CSRF token for security
      },
    };
    return await fetch(`${url}/api/get-email-token`, requestOptions)
      .then(response => response.json())
      .then(data => {
          return data;
      })
      .catch(error => console.error('Error:', error));
  };
  
  try { 
    if (formId && formData) {
      // submit form

      // Get the Bearer Token from the BE endpoint
      const bToken = await getBearerToken();
      let bEmailToken;

      // if (formId === 'dtc_signup') {
      //   queryMutation = dtcSignupQuery(formData, guideData);
      // } else
      if (formId === 'hcp_signup') {
        bEmailToken = await getEmailBearerToken();
        queryMutation = hcpSignupQuery(formData);
        // console.log(bToken, bEmailToken);
      } else if (formId === 'hcp_directory_inquiry') {
        queryMutation = hcpDirectoryInquiryQuery(formData);
      }

      // console.log(formData);
      const csrfToken = csrfCookie();

      (formId === 'hcp_signup') && queryMutation && promiseArray.push(
        putJson(
          `${url}/api/form-submit/sign-up-hcp`,
          {
            query: JSON.stringify(queryMutation),
            instance_url: bToken?.instance_url,
            formData,
            formId,
          },
          {
            'X-Authorization-Proxy': bToken?.access_token,
            'X-Authorization-Proxy-CRM': bEmailToken,
            'X-Csrf-Token': csrfToken, // CSRF token for security
            'X-Captcha-Token': captchaToken, // add the captcha token to the request headers
          }
        )
      );

      (formId === 'hcp_directory_inquiry') && queryMutation && promiseArray.push(
        putJson(
          `${url}/api/form-submit/hcp-di`,
          {
            query: JSON.stringify(queryMutation),
            instance_url: bToken?.instance_url,
            formId,
          },
          {
            'X-Authorization-Proxy': bToken?.access_token,
            'X-Authorization-Proxy-CRM': bEmailToken,
            'X-Csrf-Token': csrfToken, // CSRF token for security
            'X-Captcha-Token': captchaToken, // add the captcha token to the request headers
          }
        )
      );

      // (formId === 'dtc_signup') && queryMutation && promiseArray.push(
      //   putJson(
      //     `${url}/api/form-submit/sign-up`,
      //     {
      //       query: JSON.stringify(queryMutation),
      //       instance_url: bToken?.instance_url,
      //       formId,
      //     },
      //     {
      //       'X-Authorization-Proxy': bToken?.access_token,
      //       'X-Csrf-Token': csrfToken, // CSRF token for security
      //       'X-Captcha-Token': captchaToken, // add the captcha token to the request headers
      //     }
      //   )
      // );
      // console.log(queryMutation);
    }
      
    await Promise.all(promiseArray);

    success = true;
  } catch (error) {
    console.log(error);

    const err = /** @type {any} */ (error);

    return {
      success: false,
      error: {
        name: err?.response?.data?.name || err?.name || 'Error',
        message: err?.response?.data?.message || err?.message || 'An unknown error occurred',
        type: err?.response?.data?.type || 'UNKNOWN_ERROR',
        code: err?.response?.data?.code || 'UNKNOWN_ERROR_CODE',
      },
    }
  }

  return {
    success,
  }
}